import { Alert, Box, Stack, Typography } from '@mui/material'

/**
 * Sampling tab placeholder.
 *
 * Access evidence (DocConvert_Quality_overview §6.2):
 *  - Parent subform: `form_frmQualitySamplingSubForm2.txt`
 *  - Inner subform: `form_frmQualityQrySampling2.txt`
 *  - Queries: `QualityQrySamplingChoose`, `QualityQrySamplingChoose_CP`, `QualityQrySamplingChoose_S`
 *
 * Behavior: chooser-style. CP code -> Contract ref dependent dropdowns,
 * inner list filtered by selection. No CRUD evidence on parent subform.
 */
export default function SamplingChooserView() {
  return (
    <Box sx={{ py: 2 }}>
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" fontWeight={700}>
          Sampling
        </Typography>
        <Alert severity="info" variant="outlined">
          Tab này chưa được build chi tiết. Theo Access (`frmQualitySamplingSubForm2`) đây là
          chooser CP code → Contract ref + grid kết quả từ query `QualityQrySamplingChoose`.
        </Alert>
        <Typography variant="body2" color="text.secondary">
          Tham khảo <code>DocConvert_Quality_overview.md §6.2</code> trước khi implement.
        </Typography>
      </Stack>
    </Box>
  )
}
